/**
 * Cutting text short, visibly (#360). The agent worker has a copy (apps/agent-worker/src/truncate.ts): it takes only
 * types from MKCore. Change the marker in both.
 */

/** The most of the final answer of an agent run that is kept: on the run (outcome) and in its answer event. */
export const RUN_OUTCOME_MAX_CHARS = 200_000;

/** The marker behind a text that was cut short; n is the length of the whole text. */
export const truncatedMarker = (n: number) => `… (truncated, ${n} characters)`;

/**
 * The text as is when it fits in max characters, else its start plus the marker, together at most max characters.
 * Never a silent cut: whoever reads it sees that there was more and how much.
 */
export function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  const marker = truncatedMarker(text.length);
  let end = Math.max(0, max - marker.length);
  // Not half an emoji: a cut between the two halves of a surrogate pair leaves an invalid character.
  if (end > 0 && /[\uD800-\uDBFF]/.test(text[end - 1]!)) end--;
  return `${text.slice(0, end)}${marker}`;
}
